import { memo } from 'react';
import '../style.css';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react/dist/iconify.js';
import { CRIcon } from '@/components/crRender';

const PopupBase = ({ name, title, large, onClose, children }) => {

    const { t } = useTranslation()

    return (
        <div className={`modal fade popup window-popup-scroll`} id={name} tabIndex="-1" role="dialog" 
            onClick={onClose}
        >
            <div className={`modal-dialog ${large ? "modal-xl" : ""}`} role="document">
                <div className="modal-content"
                    onClick={e => e.stopPropagation()}
                >
                    <div className="modal-body">
                        <div className='popup-title d-flex justify-content-between align-items-center'>
                            <div>
                                {t(title)}
                            </div>
                            <div className='pointer close-btn' >
                                <CRIcon onClick={onClose} icon="line-md:close-circle-filled" />
                            </div>
                        </div>
                        <div className='popup-content'>
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default memo(PopupBase);